export default class Field {

  constructor ($el, classname) {
    this.$el = $el;
    this.classname = classname;

    this.$el = $el;
    this.type = $el.dataset.type;
    this.name = null;
    this.required = $el.classList.contains(`${this.classname}--required`);
    this.withCondition = $el.classList.contains(`${this.classname}--with-condition`);
    this.validation = $el.dataset.validation || null;
    this.valid = true;
    this.shouldValidate = true;
    this.isHidden = false;
    this.placeholder = null;
    this.message = null;
    this.delegate = null;

    this.messageInvalid = null;
    this.messageRequired = null;

    // Bind elements
    this.$message = null;
    this.$placeholder = null;
    this.$input = null;
  }

  /**
   * Triggered when losing focus.
   */
  onBlur () {
    // Remove focus modifier
    this.$el.classList.remove(`${this.classname}--focus`);

    // Trigger validation when leaving field
    this.validate();
  }

  /**
   * Triggered when gaining focus.
   */
  onFocus (evt) {
    // Set focus modifier
    this.$el.classList.add(`${this.classname}--focus`);
  }

  /**
   * Triggered on value change.
   */
  onChange () {
    // Validate on every change when field is currently invalid
    if (!this.valid) {
      this.validate();
    }

    if (this.delegate !== null) {
      this.delegate.fieldValueDidChange(this);
    }
  }

  /**
   * Returns field name.
   * This method gets called from the parent form instance.
   * @return {string} Field name
   */
  getName () {
    return this.name;
  }

  /**
   * Returns field value.
   * This method gets called from the parent form instance.
   * @return {string} Field value
   */
  getValue () {
    return this.isHidden ? '' : this.$input.value;
  }

  /**
   * Returns wether this field is valid.
   * This method gets called from the parent form instance.
   * @return {boolean}
   */
  isValid () {
    return this.shouldValidate ? this.valid : true;
  }

  /**
   * Sets wether this field is valid.
   * @param {boolean} valid
   */
  setValid (valid) {
    if (this.valid !== valid) {
      this.valid = valid;

      // Update invalid modifier
      this.$el.classList.toggle(`${this.classname}--invalid`, !valid);

      // Inform delegate about this
      this.delegate && this.delegate.fieldValidDidChange(this, valid);
    }

    return this;
  }

  /**
   * Sets the placeholder.
   * @param {string|null} [placeholder=null] Placeholder text or null to clear.
   */
  setPlaceholder (placeholder = null) {
    if (this.placeholder !== placeholder) {
      this.$placeholder.innerText = placeholder || '';
      this.$el.classList.toggle(`${this.classname}--placeholder`, !!placeholder);
      this.placeholder = placeholder;
    }
  }

  /**
   * Sets the message. Sets the original help text if set to null.
   * @param {string|null} [message=null]
   */
  setMessage (message = null) {
    if (this.$message && this.message !== message) {
      this.message = message;

      // eslint-disable-next-line no-param-reassign
      message = message || this.helpText;
      this.$message.classList.toggle(`${this.classname}__message--hidden`, !message);
      this.$message.innerText = message || '';
    }
  }

  /**
   * Sets this field's delegate and register the field as a conditional
   * if applicable
   *
   * @param {object} delegate
   * @return this
   */
  setDelegate (delegate) {
    this.delegate = delegate;

    if (this.withCondition) {

      // Do not allow fields to set themselves as conditional fields
      if (this.name !== this.$el.dataset.conditionField) {

        this.delegate.registerConditionalField(
          this,
          this.$el.dataset.conditionField,
          this.$el.dataset.conditionValue
        );
      }
    }

    return this;
  }

  /**
   * Validates field.
   * This method gets called from the parent form instance.
   * @return {boolean}
   */
  validate () {
    const value = this.getValue();

    if (!this.shouldValidate) {
      // Skip validation if field should not be validated
      return true;
    }

    // Check if checking is required
    const valid = !this.required || (this.required && value);
    this.setValid(valid);

    return this.isValid();
  }

  /**
   * Called from the delegate this function takes care of handling
   * state changes if the conditional field changed
   *
   * @param newStatus
   */
  toggleConditional (newStatus) {
    if (this.$el.dataset.conditionValue === newStatus) {
      this.$el.classList.remove(`${this.classname}--hidden`);
      this.shouldValidate = true;
      this.isHidden = false;
    } else {
      this.$el.classList.add(`${this.classname}--hidden`);
      this.shouldValidate = false;
      this.isHidden = true;
    }
  }
}
